// @generated by protoc-gen-connect-query v2.2.0 with parameter "target=ts"
// @generated from file cortado/v1/admin.proto (package cortado.v1, syntax proto3)
/* eslint-disable */

import { AdminService } from "./admin_pb";

/**
 * @generated from rpc cortado.v1.AdminService.VerifyAdmin
 */
export const verifyAdmin = AdminService.method.verifyAdmin;

/**
 * @generated from rpc cortado.v1.AdminService.ListAdmins
 */
export const listAdmins = AdminService.method.listAdmins;

/**
 * @generated from rpc cortado.v1.AdminService.CreateAnnouncement
 */
export const createAnnouncement = AdminService.method.createAnnouncement;

/**
 * @generated from rpc cortado.v1.AdminService.ListAnnouncements
 */
export const listAnnouncements = AdminService.method.listAnnouncements;

/**
 * @generated from rpc cortado.v1.AdminService.ListAnnouncementReads
 */
export const listAnnouncementReads = AdminService.method.listAnnouncementReads;

/**
 * @generated from rpc cortado.v1.AdminService.ArchiveAnnouncement
 */
export const archiveAnnouncement = AdminService.method.archiveAnnouncement;

/**
 * @generated from rpc cortado.v1.AdminService.GetEmailMarketingOverview
 */
export const getEmailMarketingOverview = AdminService.method.getEmailMarketingOverview;

/**
 * @generated from rpc cortado.v1.AdminService.SyncEmailMarketingContacts
 */
export const syncEmailMarketingContacts = AdminService.method.syncEmailMarketingContacts;

/**
 * @generated from rpc cortado.v1.AdminService.RepairEmailMarketingResources
 */
export const repairEmailMarketingResources = AdminService.method.repairEmailMarketingResources;

/**
 * @generated from rpc cortado.v1.AdminService.ListEmailMarketingResources
 */
export const listEmailMarketingResources = AdminService.method.listEmailMarketingResources;

/**
 * @generated from rpc cortado.v1.AdminService.CreateEmailMarketingResource
 */
export const createEmailMarketingResource = AdminService.method.createEmailMarketingResource;

/**
 * @generated from rpc cortado.v1.AdminService.ListEmailMarketingCampaigns
 */
export const listEmailMarketingCampaigns = AdminService.method.listEmailMarketingCampaigns;

/**
 * @generated from rpc cortado.v1.AdminService.GetEmailMarketingCampaign
 */
export const getEmailMarketingCampaign = AdminService.method.getEmailMarketingCampaign;

/**
 * @generated from rpc cortado.v1.AdminService.CreateEmailMarketingCampaign
 */
export const createEmailMarketingCampaign = AdminService.method.createEmailMarketingCampaign;

/**
 * @generated from rpc cortado.v1.AdminService.UpdateEmailMarketingCampaign
 */
export const updateEmailMarketingCampaign = AdminService.method.updateEmailMarketingCampaign;

/**
 * @generated from rpc cortado.v1.AdminService.SendEmailMarketingCampaignTest
 */
export const sendEmailMarketingCampaignTest = AdminService.method.sendEmailMarketingCampaignTest;

/**
 * @generated from rpc cortado.v1.AdminService.LaunchEmailMarketingCampaign
 */
export const launchEmailMarketingCampaign = AdminService.method.launchEmailMarketingCampaign;

/**
 * @generated from rpc cortado.v1.AdminService.RefreshEmailMarketingCampaignStatus
 */
export const refreshEmailMarketingCampaignStatus = AdminService.method.refreshEmailMarketingCampaignStatus;

/**
 * @generated from rpc cortado.v1.AdminService.GetSystemSettings
 */
export const getSystemSettings = AdminService.method.getSystemSettings;

/**
 * @generated from rpc cortado.v1.AdminService.UpdateSystemSettings
 */
export const updateSystemSettings = AdminService.method.updateSystemSettings;

/**
 * @generated from rpc cortado.v1.AdminService.GetAiOrbConfig
 */
export const getAiOrbConfig = AdminService.method.getAiOrbConfig;

/**
 * @generated from rpc cortado.v1.AdminService.UpdateAiOrbConfig
 */
export const updateAiOrbConfig = AdminService.method.updateAiOrbConfig;

/**
 * @generated from rpc cortado.v1.AdminService.RequeueFailedWorkflowTriggerEvents
 */
export const requeueFailedWorkflowTriggerEvents = AdminService.method.requeueFailedWorkflowTriggerEvents;

/**
 * @generated from rpc cortado.v1.AdminService.ResetWorkflowActionEffect
 */
export const resetWorkflowActionEffect = AdminService.method.resetWorkflowActionEffect;

/**
 * @generated from rpc cortado.v1.AdminService.ListFailedWorkflowTriggerEvents
 */
export const listFailedWorkflowTriggerEvents = AdminService.method.listFailedWorkflowTriggerEvents;

/**
 * @generated from rpc cortado.v1.AdminService.RequeueWorkflowTriggerEvent
 */
export const requeueWorkflowTriggerEvent = AdminService.method.requeueWorkflowTriggerEvent;

/**
 * ==================== Billing v2 admin ====================
 *
 * @generated from rpc cortado.v1.AdminService.AdminListOrganizationBilling
 */
export const adminListOrganizationBilling = AdminService.method.adminListOrganizationBilling;

/**
 * @generated from rpc cortado.v1.AdminService.AdminGetOrganizationBilling
 */
export const adminGetOrganizationBilling = AdminService.method.adminGetOrganizationBilling;

/**
 * @generated from rpc cortado.v1.AdminService.AdminSetBillingStartDate
 */
export const adminSetBillingStartDate = AdminService.method.adminSetBillingStartDate;

/**
 * @generated from rpc cortado.v1.AdminService.AdminResetTrialEligibility
 */
export const adminResetTrialEligibility = AdminService.method.adminResetTrialEligibility;

/**
 * @generated from rpc cortado.v1.AdminService.AdminAssignPlan
 */
export const adminAssignPlan = AdminService.method.adminAssignPlan;

/**
 * @generated from rpc cortado.v1.AdminService.AdminSetPlanEligibility
 */
export const adminSetPlanEligibility = AdminService.method.adminSetPlanEligibility;

/**
 * @generated from rpc cortado.v1.AdminService.AdminListPlanEligibility
 */
export const adminListPlanEligibility = AdminService.method.adminListPlanEligibility;

/**
 * @generated from rpc cortado.v1.AdminService.AdminInviteCccTrial
 */
export const adminInviteCccTrial = AdminService.method.adminInviteCccTrial;

/**
 * @generated from rpc cortado.v1.AdminService.AdminCreateRateException
 */
export const adminCreateRateException = AdminService.method.adminCreateRateException;

/**
 * @generated from rpc cortado.v1.AdminService.AdminListRateExceptions
 */
export const adminListRateExceptions = AdminService.method.adminListRateExceptions;

/**
 * @generated from rpc cortado.v1.AdminService.AdminRevokeRateException
 */
export const adminRevokeRateException = AdminService.method.adminRevokeRateException;

/**
 * @generated from rpc cortado.v1.AdminService.AdminSetAccessOverride
 */
export const adminSetAccessOverride = AdminService.method.adminSetAccessOverride;

/**
 * @generated from rpc cortado.v1.AdminService.AdminRevokeAccessOverride
 */
export const adminRevokeAccessOverride = AdminService.method.adminRevokeAccessOverride;

/**
 * @generated from rpc cortado.v1.AdminService.AdminForceCancelSubscription
 */
export const adminForceCancelSubscription = AdminService.method.adminForceCancelSubscription;

/**
 * @generated from rpc cortado.v1.AdminService.AdminGetBillingLaunchConfig
 */
export const adminGetBillingLaunchConfig = AdminService.method.adminGetBillingLaunchConfig;

/**
 * @generated from rpc cortado.v1.AdminService.AdminUpdateBillingLaunchConfig
 */
export const adminUpdateBillingLaunchConfig = AdminService.method.adminUpdateBillingLaunchConfig;

/**
 * @generated from rpc cortado.v1.AdminService.AdminResyncSeats
 */
export const adminResyncSeats = AdminService.method.adminResyncSeats;

/**
 * @generated from rpc cortado.v1.AdminService.AdminListRetentionDue
 */
export const adminListRetentionDue = AdminService.method.adminListRetentionDue;

/**
 * @generated from rpc cortado.v1.AdminService.AdminResyncBillingState
 */
export const adminResyncBillingState = AdminService.method.adminResyncBillingState;

/**
 * @generated from rpc cortado.v1.AdminService.AdminGetPlatformRevenueMetrics
 */
export const adminGetPlatformRevenueMetrics = AdminService.method.adminGetPlatformRevenueMetrics;

/**
 * ==================== Support sessions ====================
 *
 * @generated from rpc cortado.v1.AdminService.StartSupportSession
 */
export const startSupportSession = AdminService.method.startSupportSession;

/**
 * @generated from rpc cortado.v1.AdminService.EndSupportSession
 */
export const endSupportSession = AdminService.method.endSupportSession;

/**
 * @generated from rpc cortado.v1.AdminService.ListSupportSessions
 */
export const listSupportSessions = AdminService.method.listSupportSessions;
